const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export const toDateInputValue = (value) => {
  if (value == null || value === '') return '';

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return formatLocalDate(value);
  }

  const str = String(value).trim();
  if (DATE_ONLY_REGEX.test(str)) return str;
  if (str.includes('T')) return str.slice(0, 10);

  const parsed = new Date(str);
  if (!Number.isNaN(parsed.getTime())) {
    return formatLocalDate(parsed);
  }

  return '';
};

export const parseLocalDate = (value) => {
  const normalized = toDateInputValue(value);
  if (!normalized) return null;

  const [year, month, day] = normalized.split('-').map(Number);
  const date = new Date(year, month - 1, day, 12, 0, 0, 0);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatLocalDate = (date) => {
  const parsed = date instanceof Date ? date : parseLocalDate(date);
  if (!parsed) return '';

  const y = parsed.getFullYear();
  const m = String(parsed.getMonth() + 1).padStart(2, '0');
  const d = String(parsed.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const getStartOfToday = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

export const getTodayString = () => formatLocalDate(new Date());

export const addDays = (value, days) => {
  const date = parseLocalDate(value);
  if (!date) return '';
  date.setDate(date.getDate() + days);
  return formatLocalDate(date);
};

export const addMonthsToDateString = (value, months) => {
  const date = parseLocalDate(value);
  if (!date) return '';
  date.setMonth(date.getMonth() + months);
  return formatLocalDate(date);
};

export const getNightsBetween = (checkIn, checkOut) => {
  const start = toDateInputValue(checkIn);
  const end = toDateInputValue(checkOut);
  if (!start || !end) return 0;

  const [sy, sm, sd] = start.split('-').map(Number);
  const [ey, em, ed] = end.split('-').map(Number);
  const startUtc = Date.UTC(sy, sm - 1, sd);
  const endUtc = Date.UTC(ey, em - 1, ed);
  const nights = Math.round((endUtc - startUtc) / (1000 * 3600 * 24));

  return nights > 0 ? nights : 0;
};

export const isValidStayRange = (checkIn, checkOut) => getNightsBetween(checkIn, checkOut) > 0;

export const formatDisplayDate = (value) => {
  const date = parseLocalDate(value);
  if (!date) return '—';

  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

export const getDefaultStayDates = () => {
  const checkInStr = getTodayString();
  const checkOutStr = addDays(checkInStr, 1);

  return {
    checkIn: parseLocalDate(checkInStr),
    checkOut: parseLocalDate(checkOutStr),
    checkInStr,
    checkOutStr,
    numberOfDays: 1,
  };
};

export const getDefaultBookingFilterRange = (monthsAhead = 1) => {
  const fromDate = getTodayString();
  return {
    fromDate,
    toDate: addMonthsToDateString(fromDate, monthsAhead),
  };
};

export const normalizeStayPayload = (checkIn, checkOut) => ({
  checkInDate: toDateInputValue(checkIn),
  checkOutDate: toDateInputValue(checkOut),
  numberOfDays: getNightsBetween(checkIn, checkOut),
});
